import React from "react";
import i18n from "../../../../i18n";
import { Trans } from "react-i18next";
import NumericFormat from "../../../../components/react-number-format/NumericFormat";
import { operationTypes } from "../../../../constants";
var tKey = "contexts.ExchangeContext.CreateExchangeDialog.ExchangeWizardForm.validate";
var validate = function validate(values) {
  var errors = {};
  if (!values.variantInvestmentItem) errors.variantInvestmentItem = i18n.t("".concat(tKey, ".variantInvestmentItem_missing"));
  if (!values.goal) errors.goal = i18n.t("".concat(tKey, ".goal_missing"));
  if (!values.broker) errors.broker = i18n.t("".concat(tKey, ".broker_missing"));
  if (!values.requestedCurrencyAmount) errors.requestedCurrencyAmount = i18n.t("".concat(tKey, ".requestedCurrencyAmount_missing"));else if (values.type === operationTypes.BUY && values.minimumCurrencyAmount && values.requestedCurrencyAmount < values.minimumCurrencyAmount && !values.boost) errors.requestedCurrencyAmount = /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".requestedCurrencyAmount_belowMin"),
    components: {
      minimumCurrencyAmount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        value: values.minimumCurrencyAmount,
        className: "fw-bold me-1"
      }),
      small: /*#__PURE__*/React.createElement("small", null)
    },
    values: {
      unitAbbreviation: values.price.currency.unitAbbreviation
    }
  });
  if (!values.investmentItemAmount) errors.investmentItemAmount = i18n.t("".concat(tKey, ".investmentItemAmount_missing"));else if (values.type === operationTypes.SELL && values.investmentItemAmount > values.investmentItemAmountAvailable) errors.investmentItemAmount = /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "".concat(tKey, ".investmentItemAmount_aboveMax"),
    components: {
      minimumCurrencyAmount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        value: values.investmentItemAmountAvailable,
        className: "fw-bold me-1"
      }),
      small: /*#__PURE__*/React.createElement("small", null)
    },
    values: {
      unitAbbreviation: values.variantInvestmentItem.unitAbbreviation
    }
  });
  return errors;
};
export default validate;